"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Breadcrumb = require("./Breadcrumb.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 麵包屑
 */
var Breadcrumb = function Breadcrumb(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      mb = _ref.mb;
  return /*#__PURE__*/_react.default.createElement(_Breadcrumb.UiBreadcrumb, {
    mb: mb
  }, /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb, null, data.map(function (item, index, arr) {
    return /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, {
      key: item.name
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.path,
      disabled: arr.length === index + 1
    }, item.oneClassIcon && item.oneClassIcon, item.icon && /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons-outlined"
    }, item.icon), item.name));
  })));
};

var _default = Breadcrumb;
exports.default = _default;
Breadcrumb.propTypes = {
  data: _propTypes.default.array,
  mb: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};